<template>
  <div class="matchresultconsole">
    <div class="commonpageheader">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{name: 'Subscription'}">订阅管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{name: 'ProductInfoList', params: {subid: query.subid}, query: { page: productinfopage }}">标准信息表</el-breadcrumb-item>
        <el-breadcrumb-item>商品匹配结果管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="filterbox">
      <el-form size="small" label-width="100px">
        <div class="smallelform">
          
          <el-row>
            <el-col :span="16">
              <el-form-item label="订阅名称">{{baseinfo.TaskName}}</el-form-item>
            </el-col>
            <el-col :span="8" style="padding-left:25px;">
              <el-button size="small" type="primary" plain @click="goToManager()">查看匹配规则</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8"><el-form-item label="TaskID">{{baseinfo.TaskID}}</el-form-item></el-col>
            <el-col :span="8"><el-form-item label="SKU常规检测价">{{skuinfo.price}}</el-form-item></el-col>
            <el-col :span="8"><el-form-item label="用戶SKUCode">{{skuinfo.skucode}}</el-form-item></el-col>
          </el-row>
        </div>
        <div class="skuurlmatchselectgroup skuurlmatchselectgroupinfo">
          <el-row>
            <el-col :span="8">
              <el-form-item label="SKUID">{{ skuinfo.id }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SKU名称">{{ skuinfo.productName }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SKU描述">{{ skuinfo.descripition === 'undefined' ? '' : skuinfo.descripition }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="SKU系列">{{ skuinfo.series }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SKU型号">{{ skuinfo.model }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="SKU参数">{{ skuinfo.specification }}</el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-row>
        <el-col :span="16">
          <el-form size="small" label-width="100px">
            <el-form-item label="关键词">
              <el-input @keyup.enter.native="getResultList(0)" v-model="query.search" placeholder="请输入AssetID、商品标题或SkuMap" class="matchresultconsolekeywords"></el-input>
              <el-button type="primary" @click="getResultList(0)">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8">
          <div class="setallfeedback">
            <el-tag>剩余未读({{ feedbackcounts }})</el-tag>
            <el-button v-if="!disabled3" :disabled="feedbackcounts/1 === 0" icon="el-icon-circle-check" type="success" size="small" @click="setAllRead()">当前页面全部设为已读</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="commontable">
      <div class="tablebox">
        <el-table 
          :cell-style="getCellStyle" 
          size="small" 
          :data="tablelist" 
          @sort-change="sortthiscolumn" 
          :row-class-name="blodUnCheckRow"
          @selection-change="handleSelectionChange" 
        >
          <el-table-column prop="AssetId" 
            type="selection" 
            width="50" 
            column-key='AssetId'
          >
          </el-table-column>
          <el-table-column width="30px">
            <template slot-scope="scope">
              <span class="reviewtypeicon" :class="scope.row.CheckTime !== null ? 'isreadtype' : ''"></span>
            </template>
          </el-table-column>
          <el-table-column prop="AssetID" label="AssetID" width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip label="商品标题" width="350px">
            <template slot-scope="scope">
              <a :href="scope.row.AssetURL" target="_blank" v-html="scope.row.AssetTitle"></a>
            </template>
          </el-table-column>
          <el-table-column label="SKUMAP" width="350px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-html="scope.row.SkuMap"></span>
            </template>
          </el-table-column>
          <el-table-column prop="AssetContent" label="商品描述" show-overflow-tooltip></el-table-column>
          <el-table-column prop="Price" label="Price" width="100px"></el-table-column>
					<el-table-column label="下架" width="60px">
            <template slot-scope="scope">
              <el-switch
                :disabled="disabled3"
                @change="takedownItem(scope.row)"
                v-model="scope.row.isDel"
                active-color="#13ce66"
                inactive-color="#999999"
                :active-value="1"
                :inactive-value="0">
              </el-switch>            
            </template>
          </el-table-column>
          <el-table-column label="SKUID" width="100px">
            <template slot-scope="scope">
              <el-input size="mini"
              :disabled="disabled3"
              v-model="scope.row.SkuId" 
              @keyup.enter.native="keyupEnterSaveSkuId(scope.row, $event)"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div class="table-pagination table-pagination-left">
        <el-row>
          <el-col :span="16">
            <el-pagination
              small
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              popper-class="pagesizeclass"
              :page-sizes="[25, 50, 100]"
              :page-size="query.size"
              layout="total, prev, pager, next, sizes"
              :total="totalbrand"
            ></el-pagination>
            <div style="width:200px; float:left;">
              <el-input style="width:100px;" placeholder="输入SKUID" 
                v-model="multiedit.skuid" @keyup.enter.native="multiEditSkuid" size="mini"></el-input>
              <el-button 
                :disabled='disablededitbtn'
                type="primary" 
                style="width:90px; margin-left:10px;" size="mini" @click="multiEditSkuid">批量设置</el-button>
            </div>     
          </el-col>
          <el-col :span="8">
            <div class="setallfeedback" style="text-align:right;">
              <el-tag>剩余未反馈({{ feedbackcounts }})</el-tag>
              <el-button v-if="!disabled3" :disabled="feedbackcounts/1 === 0" icon="el-icon-circle-check" type="success" size="small" @click="setAllRead()">当前页全部设为已反馈</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      autofocus: true,
      keywords: "",
      loading: false,
      query: {
        subid: this.$route.params.subid,
        skuid: this.$route.params.skuid,
        search: "",
        page: 1,
        size: this.getLocalStorage('pagesize5') ? this.getLocalStorage('pagesize5') * 1 : 25,
        type: 0,
        order: ''
      },
      currentPage: 1,
      tablelist: [],
      totalbrand: 0,
      skulists: [],
      baseinfo: {},
      skuinfo: {},
      assetidlist: '',
      blurtype: 0,
      feedbackcounts: '',
      productinfopage: 0,
      highlightkeywords: [],
      ruleform: {},
      ruleid: 0,
      norule: true,
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false,
      newskuid: '',
      multiedit: {
        assetid: [],
        skuid: '',
        subid: ''
      },
      disablededitbtn: true
    }
  },

  mounted() {
    let that = this
    this.productinfopage = JSON.parse(localStorage.getItem("currentpage")).val
    this.getSkuInfo()
    this.getBaseInfo()
    // this.getSkuList()
    this.getFeedbackCount()
    this.getRule(function(){
      that.getResultList(0)
    })
  },

  methods: {

    getCellStyle({ column }) {
      // TODO 针对Safari表格width与showOverflowTooltip暂不能共存异常
      const tempWidth = column.realWidth || column.width
      if (column.showOverflowTooltip) {
        return {
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }

      return {}
    },
    
    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize5', val)
      that.getResultList(0)
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.query.page = val
      that.getResultList(0)
    },

    /**
     * 搜索联想
     */
    querySearch(queryString, cb) {
      this.blurtype = 1
      let slists = this.skulists
      let results = queryString ? slists.filter(this.createFilter(queryString)) : slists
      cb(results)
    },

    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0)
      }
    },

    /**
     * 修改行内SKUID
     */
    editSkuId: function(row, column){
      if(column.label === 'SKUID'){
        row.isedittype = true
      }
      console.log(this)
    },

    /**
     * SKUID输入框失去焦点
     */
    saveSkuId: function(row){
      let that = this
      if(row.SkuId === ''){
        that.$message.error('SKUID不能为空')
        return false
      }
      that.changeSkuId(row)
      row.isedittype = true
      row.CheckTime = new Date()
    },

    /**
     * 回车提交SKUID修改
     */
    keyupEnterSaveSkuId: function(row, e){
      let that = this
      if(row.SkuId === ''){
        that.$message.error('SKUID不能为空')
        return false
      }
      if(isNaN(row.SkuId)){
        that.$message.error('SKUID只能输入大于等于-1的数')
        return false
      }
      if(row.SkuId/1 < -1){
        that.$message.error('SKUID只能输入大于等于-1的数')
        return false
      }
      that.changeSkuId(row)
      e.target.blur()
    },

    /**
     * 联想搜索下拉选中
     */
    // handleSelect: function(row) {
    //   let that = this
    //   that.changeSkuId(row)
    // },

    /**
     * 保存SKUID修改
     */
    changeSkuId: function(row){
      let that = this
      row.isedittype = false
      let url = that.API_URL + '/sys/rule/item'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {subid: that.query.subid, skuid: row.SkuId, assetid: row.AssetID},
        success: function(data) {
          console.log('changeSkuId', data)
					that.$message.success('修改成功')
          that.blurtype = 0
          that.getFeedbackCount()
        },
        error: function(response) {
          console.log('changeSkuId', response)
          that.blurtype = 0
        }
      })
    },
    
    /**
     * 获取SKU信息
     */
    getSkuInfo: function(){
      let that = this
      let url = that.API_URL + '/sys/monitor/view'
      let query = {skuid: that.query.skuid}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getSkuInfo', data)
          that.skuinfo = data.results
        },
        error: function(response) {
          console.log('getSkuInfo', response)
        }
      })
    },
    
    /**
     * 获取订阅基本信息
     */
    getBaseInfo: function(){
      let that = this
      let url = that.API_URL + '/sys/match/view'
      let query = {subid: that.query.subid}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getBaseInfo', data)
          let info = data.results[0]
          that.baseinfo = info
        },
        error: function(response) {
          console.log('getBaseInfo', response)
        }
      })
    },

    /**
     * 获取数据list
     */
    getResultList: function(sts){
      let that = this
      that.query.type = sts/1
      let url = that.API_URL + '/sys/rule/list'
      let query = that.query
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getResultList', data)
          that.totalbrand = data.results[0][0].Count
          let lists = data.results[1]
          lists.forEach(function(res){
            res.SkuId = res.SkuId + ''
            res.isedittype = false
            res.AssetTitle = that.highlighted(that.highlightkeywords, res.AssetTitle)
            res.SkuMap = that.highlighted(that.highlightkeywords, res.SkuMap)
            res.isDel = res.isDel == 2 ? 1 : res.isDel
          })

          /**
           * 获取当前页AssetID
           */
          let _assetidlist = []
          for(let i=0; i<lists.length; i++){
            _assetidlist.push(lists[i].AssetID)
          }
          that.assetidlist = _assetidlist.join(',')

          that.tablelist = lists
          that.loading = false
        },
        error: function(response) {
          console.log('getResultList', response)
        }
      })
    },

    /**
     * 获取SKU列表
     */
    getSkuList: function(){
      let that = this
      let url = that.API_URL + '/sys/monitor/list'
      let query = {subid: that.query.subid}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getSkuList', data)
          let lists = data.results
          lists.forEach(function(res){
            res.value = '' + res.id + ''
          })
          lists.push({value: '0'})
          that.skulists = lists
        },
        error: function(response) {
          console.log('getSkuList', response)
        }
      })
    },

    /**
     * 全部设为已读
     */
    setAllRead: function(){
      let that = this
      let url = that.API_URL + '/sys/rule/read'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {subid: that.query.subid, skuid: that.query.skuid, assetidlist: that.assetidlist},
        success: function(data) {
          console.log('setAllRead', data)
          that.getResultList()
          that.getFeedbackCount()
        },
        error: function(response) {
          console.log('setAllRead', response)
        }
      })
    },

    /**
     * 获取未反馈条目数
     */
    getFeedbackCount: function(){
      let that = this
      let url = that.API_URL + '/sys/rule/todo'
      let query = {subid: that.query.subid, skuid: that.query.skuid, search: that.query.search}
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getFeedbackCount', data)
          that.feedbackcounts = data.results[0].Count
        },
        error: function(response) {
          console.log('getFeedbackCount', response)
        }
      })
    },

    /**
     * 跳转至匹配规则
     */
    goToManager: function(){
      let that = this
      // that.$router.push({name: 'SKUURLMatchingManager',params: {subid: that.$route.params.subid, skuid: that.$route.params.skuid}})
      that.$router.push({name: 'SKUURLMatchingManager',params: {subid: that.$route.params.subid, poid: that.$route.params.poid, skuid: that.$route.params.skuid}})
    },

    /**
     * 加粗未反馈行
     */
    blodUnCheckRow: function({row}){
      if (row.CheckTime == null) {
        return 'uncheck-row'
      }
      return ''
    },

    /**
     * 排序
     */
    sortthiscolumn: function(column){
      if(column.prop == "Price" && column.order == "ascending"){
        this.query.order = 0
        this.getResultList(0)
      }else if(column.prop == "Price" && column.order == "descending"){
        this.query.order = 1
        this.getResultList(0)
      }else if(column.prop == "Price" && column.order == null){
        this.query.order = 0
        this.getResultList(0)
      }else{
        return
      }
    },

    /**
     * 获取规则
     */
    getRule: function(callback){

      let that = this
      let url = that.API_URL + '/sys/rule/view'
      let query = {
        subid: that.query.subid,
        skuid: that.query.skuid
      }
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getRule1', data)
          let res = data.results
          if(res.length === 0){
            that.ruluid = 0
            that.norule = true
          }else{
            let resc = res[res.length-1].rulecontent
            let resc0 = resc.substr(1)
            let resc1 = resc0.substr(0, resc0.length-1)
            let resc2 = JSON.parse(''+ resc1 +'')
            that.ruleform = resc2
            that.ruleform.rulestatus = resc2.rulestatus === 0 ? "所有条件" : "任一条件"
            that.ruleform.rulegroup.forEach(function(res){
              if(res.status === 0){
                res.status = '包含所有关键词'
              }
              if(res.status === 1){
                res.status = "包含任一关键词"
              }
              if(res.status === 2){
                res.status = "不包含任一关键词"
              }
              if(res.status === 3){
                let p = res.keywords.join("-")
                res.keywords = []
                res.keywords[0] = p
                res.status = ""
              }
            })
            that.ruleid = res[res.length-1].ruleid/1
            that.norule = false      
            that.highlightkeywords = []
            for(let i=0; i<that.ruleform.rulegroup.length; i++){
              if(that.ruleform.rulegroup[i].status === '包含所有关键词' || that.ruleform.rulegroup[i].status === '包含任一关键词'){
                that.highlightkeywords.push(...that.ruleform.rulegroup[i].keywords)
              }
            }
            console.log('getRule2', that.ruleform)
          }
          callback()
        },
        error: function(response) {
          console.log('getRule', response)
        }
      })

    },

    /**
     * 下架
     */
    takedownItem: function(row){
      let that = this
      row.isedittype = false
      let url = that.API_URL + '/sys/result/set'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {assetid: row.AssetID, status: row.isDel},
        success: function(data) {
					console.log('takedownItem', data)
					that.$message.success('修改成功')
        },
        error: function(response) {
					console.log('takedownItem', response)
					that.$message.error('修改失败')
        }
      })      
    },

    /**
     * 全选
     */
    handleSelectionChange: function(val){
      this.multiedit.assetid = val.map(item => {
        return item.AssetID
      })
      this.disablededitbtn = this.multiedit.assetid.length > 0 ? false : true
    },
    
    /**
     * 批量修改
     */
    multiEditSkuid: function(){
      let that = this
      if(that.multiedit.skuid == ''){
        this.$message.error('SKUID不能为空')
        return
      }
      let url = that.API_URL + '/sys/rule/setmoreitem'
      that.multiedit.subid = that.query.subid
      that.multiedit.assetid = that.multiedit.assetid.join(',')
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: that.multiedit,
        success: function(data) {
					console.log('multiEditSkuid', data)
					that.$message.success('修改成功')
          that.getFeedbackCount()
          that.getRule(function(){
            that.getResultList(0)
          })
        },
        error: function(response) {
					console.log('multiEditSkuid', response)
					that.$message.error('修改失败')
        }
      })
    },

  }
}
</script>
